import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:9000/api/v1';

const adminClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// Auth token management
let authToken: string | null = null;

export function setAuthToken(token: string | null) {
  authToken = token;
}

adminClient.interceptors.request.use((config) => {
  if (authToken) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }
  return config;
});

// Auto-refresh on 401 using stored refresh_token (24h session)
adminClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const rt = localStorage.getItem('admin_refresh_token');
      if (rt) {
        try {
          const { data } = await axios.post(
            `${API_BASE_URL}/auth/refresh`,
            null,
            { params: { refresh_token: rt } },
          );
          const newToken = data.access_token;
          authToken = newToken;
          localStorage.setItem('admin_token', newToken);
          if (data.refresh_token) {
            localStorage.setItem('admin_refresh_token', data.refresh_token);
          }
          original.headers['Authorization'] = `Bearer ${newToken}`;
          return adminClient(original);
        } catch {
          // Refresh failed — fall through to redirect
        }
      }
      authToken = null;
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_refresh_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default adminClient;
